import {
  SUPER_USER,
  FIELDS,
  USERS,
  GET_USER_BUSINESS_FARM,
  TRANSFER_FIELDS,
} from "../configurations/Urls";
import axios from "axios";
import SessionHelper from "../helpers/SessionHelper";

const SuperUserService = {
  async RequestToken(username) {
    if (!username) return;
    const headers = SessionHelper.getHeaderWithStaffToken();
    const response = await axios.get(`${SUPER_USER}/token/${username}`, {
      headers: headers,
    });
    return response;
  },

  async getFarmerList() {
    const headers = SessionHelper.getHeaderWithStaffToken();
    const response = await axios.get(`${SUPER_USER}/farmers`, {
      headers: headers,
    });
    return response;
  },

  async getStaffNotesForField(fieldId) {
    if (!fieldId) return;
    const headers = await SessionHelper.getHeaderWithToken();
    const response = await axios.get(`${FIELDS}/${fieldId}/note`, {
      headers: headers,
    });
    return response;
  },

  async getStaffNotesForUser() {
    const headers = await SessionHelper.getHeaderWithToken();
    const response = await axios.get(`${USERS}/note`, {
      headers: headers,
    });
    return response;
  },

  async updateFieldStaffNotes(fieldId, payload) {
    if (!fieldId || !payload) return;
    const headers = await SessionHelper.getHeaderWithToken();
    const response = await axios.put(`${FIELDS}/${fieldId}/note`, payload, {
      headers: headers,
    });
    return response;
  },
  async updateUserStaffNotes(payload) {
    if (!payload) return;
    const headers = await SessionHelper.getHeaderWithToken();
    const response = await axios.put(`${USERS}/note`, payload, {
      headers: headers,
    });
    return response;
  },

  async SendCredentialMail(username) {
    if (!username) return;
    const headers = SessionHelper.getHeaderWithStaffToken();
    const response = await axios.get(`${SUPER_USER}/creds/${username}`, {
      headers: headers,
    });
    return response;
  },
  async getFarmerBusinessAndFarms(username) {
    if (!username) return;
    const headers = SessionHelper.getHeaderWithStaffToken();
    const response = await axios.get(`${GET_USER_BUSINESS_FARM}/${username}`, {
      headers: headers,
    });
    return response;
  },
  async getFilteredFieldsToTransfer(url) {
    if (!url) return;
    const headers = SessionHelper.getHeaderWithStaffToken();
    const response = await axios.get(url, {
      headers: headers,
    });
    return response;
  },
  async transferFields(payload) {
    if (!payload) return;
    const headers = SessionHelper.getHeaderWithStaffToken();
    const response = await axios.post(TRANSFER_FIELDS, payload, {
      headers: headers,
    });
    return response;
  },
};
export default SuperUserService;
